export default function AiCallout() {
  return (
    <section className="py-20 sm:py-24" style={{ backgroundColor: '#f8f7f4' }}>
      <div className="max-w-[800px] mx-auto px-8">
        <p className="text-[11px] font-mono uppercase tracking-[2px] text-[#1a7a4c] font-medium mb-3">
          AI Analysis
        </p>
        <h2 className="font-display text-3xl sm:text-[40px] leading-[1.15] text-[#0f1a2e] tracking-tight mb-4">
          Your deals, analyzed in seconds
        </h2>
        <p className="text-[17px] leading-relaxed text-[#5a6578] mb-10">
          Most lenders evaluate deals on gut feel and a few numbers. LendSolo's AI reads your entire
          loan — principal, rate, LTV, collateral, how concentrated your portfolio is — and writes
          the analysis an experienced lender would write. Except it takes 5 seconds instead of 30
          minutes.
        </p>

        {/* Example AI output card */}
        <div className="bg-white border border-[#e2e0d8] rounded-xl p-7 mb-8">
          <div className="flex items-center gap-2.5 mb-4">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#6d28d9"
              strokeWidth="2"
              strokeLinecap="round"
            >
              <path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5L12 3z" />
              <path d="M5 19l1 3 1-3 3-1-3-1-1-3-1 3-3 1 3 1z" />
            </svg>
            <span className="font-mono text-[11px] uppercase tracking-[1px] text-[#6d28d9] font-medium">
              AI Risk Assessment
            </span>
          </div>
          <p className="text-[15px] leading-relaxed text-[#2d3a4f] italic">
            "This loan carries elevated risk across two dimensions. The 81% LTV leaves limited
            collateral cushion if the property needs to be liquidated quickly. Combined with this
            loan representing 58% of your deployed capital, a default would materially impact your
            portfolio. Consider requesting a formal appraisal and documenting the collateral
            thoroughly before funding."
          </p>
        </div>

        <p className="text-[15px] leading-relaxed text-[#5a6578]">
          Every Pro account gets AI deal memos you can copy, download as PDF, and share with
          partners or attorneys. Built on the same AI that powers Claude — not a template with your
          numbers plugged in.
        </p>
      </div>
    </section>
  )
}
